<!-- eslint-disable vue/multi-word-component-names -->
<script setup lang="js">
import { computed, inject } from 'vue';
import { storeToRefs } from 'pinia';
import _ from 'lodash';
import { useModalStore } from '@/stores/modal.store';

const store = inject('autoStore');

const {
  outputEntities,
  customVariables,
  getAvailableOutputVarsRequest
} = storeToRefs(store);

const modalStore = useModalStore();

const outputEntitiesView = computed(() => {
  const customObj = _.keyBy(customVariables.value, 'name');
  const fieldsObj = _.keyBy(getAvailableOutputVarsRequest.value.data, 'name');

  return outputEntities.value.map(ent => {
    return {
      variableTitle: customObj[ent.variable].title
        || 'Отсутствует переменная',
      fieldTitle: fieldsObj[`${ent.entity}.${ent.entity_id}`].title
        || 'Отсутствует переменная',
    };
  });
});

function openOutputModal(itemIndex) {
  modalStore.openModal('OutputModal', {
    outputEntity: outputEntities.value[itemIndex] ?? itemIndex,
    customVariables: customVariables.value,
    availableOutputEntities: getAvailableOutputVarsRequest.value.data,
  }).then(({ event, params }) => {
    if (event !== 'save') return;

    if (_.isNumber(itemIndex)) {
      outputEntities.value[itemIndex] = params;
    } else {
      outputEntities.value.push(params);
    }

    modalStore.closeModal();
  }).catch(() => {});
}

function openDeleteModal(itemIndex) {
  modalStore.openModal('ConfirmModal', {
    title: "Вы действительно хотите удалить эту строку?",
    btnConfirm: "Удалить",
  }).then(({ event }) => {
    if (event !== MODAL_CONFIRM) return;

    outputEntities.value.splice(itemIndex, 1);
    modalStore.closeModal();
  }).catch(() => {});
}
</script>

<template>
  <div class="autoform-variables">
    <div class="d-flex justify-content-between align-items-center input-btns">
      <div class="add-btn" @click="openOutputModal()">
        <img src="@/assets/img/plus-ico.svg" alt="plus-ico.svg" />
        Добавить выходные данные
      </div>
    </div>
    <div class="table-responsive">
      <table class="table gray-table">
        <thead>
          <tr>
            <th>Переменная</th>
            <th>Поле (в исполняемой системе)</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(outputEntity, index) in outputEntitiesView" :key="index">
            <td>
              {{ outputEntity.variableTitle }}
            </td>
            <td>
              {{ outputEntity.fieldTitle }}
            </td>
            <td>
              <div class="table-buttons">
                <div class="table-button" @click="openOutputModal(index)">
                  <span class="edit-ico" />
                </div>
                <div class="table-button" @click="openDeleteModal(index)">
                  <span class="delite-ico" />
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
